
import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center p-12">
      <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
      <p className="text-primary-light text-center max-w-md">
        Analyzing customer priorities, KPIs, and business framework to generate strategic sales recommendations...
      </p>
    </div>
  );
};

export default LoadingState;
